import { useState, useEffect } from 'react';
import { getSalesforceMessagingUrl, getJwt } from './src-utils-miaw-chat-config.js';
import { useNRLogging } from './src-hooks-custom-hooks-useNRLogging.js';

const useMIAWUploadFile = () => {
  const { logCustomAttributesNR } = useNRLogging();
  const messagingUrl = getSalesforceMessagingUrl();
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState();
  const [data, setData] = useState([]);
  const [requestData, setRequestData] = useState();
  const trigger = (requestData2) => {
    setRequestData(requestData2);
  };
  useEffect(() => {
    const uploadFile = async () => {
      logCustomAttributesNR("ca-chatbot-miaw-api-request", {
        logLevel: "info",
        message: "Starting file upload",
        apiType: "miawUploadFile"
      });
      setLoading(true);
      setError(void 0);
      setData([]);
      if (!Array.isArray(requestData?.payload) || !requestData.payload.length) {
        setError(new Error("Incorrect payload, please pass a non-empty array"));
        setLoading(false);
        throw new Error(`Incorrect payload, Please pass the correct payload`);
      }
      try {
        const UploadPromise = requestData.payload.map((payload) => {
          if (requestData?.message) {
            payload.messageEntry.message.text = requestData.message;
          }
          const formData = new FormData();
          const jsonBlob = new Blob([JSON.stringify(payload.messageEntry)], { type: "application/json" });
          formData.append("messageEntry", jsonBlob);
          formData.append("fileData", payload.fileData, payload.fileData.name);
          return fetch(`${messagingUrl}/iamessage/api/v2/conversation/${payload.conversationId}/file`, {
            method: "POST",
            body: formData,
            headers: {
              Authorization: "Bearer " + getJwt()
            }
          });
        });
        const results = await Promise.allSettled(UploadPromise);
        results.forEach(async (result, index) => {
          const originalPayload = requestData.payload[index];
          if (result.status === "fulfilled") {
            const response = result.value;
            let parsedBody = null;
            try {
              parsedBody = await response.json();
            } catch (err) {
              setError(err.message);
            }
            setData((prev) => [...prev, { data: parsedBody, status: response.status, fileName: originalPayload.fileData.name }]);
          }
        });
        logCustomAttributesNR("ca-chatbot-miaw-api-response", {
          logLevel: "info",
          message: "File upload completed",
          apiType: "miawUploadFile"
        });
      } catch (err) {
        if (err instanceof Error) {
          setError(new Error(err.message));
        } else {
          setError(new Error("Unexpected error occurred"));
        }
        logCustomAttributesNR("ca-chatbot-miaw-api-error", {
          errorName: err?.name,
          errorStack: err?.stack,
          message: err?.message,
          logLevel: "error",
          apiType: "miawUploadFile"
        });
      } finally {
        setLoading(false);
      }
    };
    if (requestData) {
      uploadFile();
    }
  }, [requestData]);
  return {
    data,
    loading,
    error,
    trigger
  };
};

export { useMIAWUploadFile };
//# sourceMappingURL=src-hooks-miaw-useMIAWUploadFile.js.map
